import React from "react";
import { useTranslation } from "react-i18next";
import { FiShieldOff } from "react-icons/fi";
import { SurveyOutcomeCard } from "pages/SurveyComplete/SurveyOutcomeCard";

export const UserSecurityTerminate = ({ isHmacFailed }: any) => {
  const { t } = useTranslation();
  return (
    <SurveyOutcomeCard
      tone="danger"
      icon={FiShieldOff}
      title={isHmacFailed ? t("page.surveysecurityterminate.internal") : t("page.surveyterminate.SurveyHave")}
      actions={
        <a href="/join-now" className="zs-btn zs-btn-primary zs-btn-lg zs-btn-block">
          {t("page.surveyterminate.mysurveys")}
        </a>
      }
    >
      <p>
        {t("page.terminate.Explore")}
      </p>
      <p className="rounded border border-line bg-surface-2 px-4 py-3 text-[13px] text-ink-3">
        {t("page.terminate.case")}
      </p>
    </SurveyOutcomeCard>
  );
};
